const SECTIONS = [
  {
    h: "1. Acceptance of Terms",
    p: "By accessing or using It Is Established (\"the App\"), operated by War-Zone Global Ministry, you agree to be bound by these Terms & Conditions. If you do not agree, please do not use the App.",
  },
  {
    h: "2. Purpose of the App",
    p: "The App generates first-person declarations rooted in Bible scripture based on topics you provide. It is intended for personal devotional and faith-building use. The decrees are generated with the assistance of artificial intelligence and drawn from publicly available Bible translations.",
  },
  {
    h: "3. Not Professional Advice",
    p: "Content provided by the App is for spiritual encouragement only and does not constitute medical, legal, financial, or professional advice. Always seek qualified professionals for such matters.",
  },
  {
    h: "4. Accounts",
    p: "You are responsible for maintaining the confidentiality of your account credentials and for all activity under your account. You agree to provide accurate information and to notify us of any unauthorized use.",
  },
  {
    h: "5. Acceptable Use",
    p: "You agree not to misuse the App, including attempting to disrupt its operation, reverse engineer it, or use it to generate content that is unlawful, hateful, or contrary to its devotional purpose.",
  },
  {
    h: "6. Intellectual Property",
    p: "The App, its name, design, and original content are the property of War-Zone Global Ministry. Scripture quotations are drawn from their respective copyright holders and publicly available translations and remain the property of those holders.",
  },
  {
    h: "7. User Content",
    p: "Topics, feedback, and profile information you submit remain yours, but you grant us a limited license to process and display them within the App for the purpose of providing the service.",
  },
  {
    h: "8. Limitation of Liability",
    p: "The App is provided \"as is\" without warranties of any kind. To the fullest extent permitted by law, War-Zone Global Ministry shall not be liable for any indirect or consequential damages arising from use of the App.",
  },
  {
    h: "9. Termination",
    p: "We may suspend or terminate access to the App at our discretion if these Terms are violated.",
  },
  {
    h: "10. Governing Law & Contact",
    p: "These Terms are governed by applicable law in the jurisdiction of War-Zone Global Ministry. For questions, contact admin@warzoneglobal.com.",
  },
];

export default function Terms() {
  return (
    <div className="max-w-3xl mx-auto px-6 sm:px-8 pt-16 pb-24" data-testid="terms-page">
      <p className="font-body text-sm uppercase tracking-[0.2em] text-[#7A756E]">Legal</p>
      <h1 className="font-heading text-4xl sm:text-5xl text-[#2C2A29] tracking-tight mt-3">Terms &amp; Conditions</h1>
      <p className="font-body text-sm text-[#7A756E] mt-4">Last updated: {new Date().toLocaleDateString()}</p>
      <div className="mt-10 space-y-8">
        {SECTIONS.map((s) => (
          <section key={s.h}>
            <h2 className="font-heading text-xl text-[#2C2A29] tracking-tight">{s.h}</h2>
            <p className="font-body text-base leading-relaxed text-[#4A4744] mt-2">{s.p}</p>
          </section>
        ))}
      </div>
    </div>
  );
}
